import { useNavigate } from "react-router";
import { getI18n, useTranslation } from "react-i18next";
import { useEffect, useState } from "react";


function DownloadMenus({ visible, onClose, style, downloadList }) {
  const lang = getI18n().language;
  let clickAway = null;
  useEffect(() => {
    clickAway = document.body.addEventListener("click", (e) => {
      if (e.target.id.indexOf("DOWNLOAD_MENUS") == -1) {
        onClose(false);
      }
    });

    return () => {
      if (clickAway) {
        document.body.removeEventListener("click");
      }
    };
  }, []);
  return (
    <>
      <div
        id="DOWNLOAD_MENUS"
        onClick={onClose}
        style={{
          boxShadow: "0 2px 15px rgba(0,0,0,.3)",
          zIndex: 99,
          display: visible ? "block" : "none",
          ...style,
        }}
        className="rounded-[5px] absolute bg-white overflow-hidden top-[40px]"
      >
        <ul className="divide-[#eee] divide-y">
          {downloadList.map(
            (item, i) =>
              item.url && (
                <li
                  className="px-[20px] w-[150px] py-[12px] cursor-pointer hover:bg-[#eee] text-center"
                  key={i}
                >
                  {item.url && (
                    <a href={item.url} target="_blank">
                      {lang == "en" ? item.nameEN : item.name}
                    </a>
                  )}
                </li>
              )
          )}
        </ul>
      </div>
    </>
  );
}

export default function HeaderNav({ navs, type, style, navStyle }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = getI18n().language;
  const [downloadMenus, setDownloadMenus] = useState(false);

  const closeDownloadMenus = () => {
    setDownloadMenus(false);
  };

  return (
    <div
      className={
        "container-center ml-[20px] md:flex lg:max-w-[1000px] lg:pb-[20px] md:pb-[10px] mdmax:hidden relative"
      }
      style={style}
    >
      {navs.map((item, index) => (
        <div>
          {item.path === "/appDownload" ? (
            item.ios?.url || item.android?.url ? (
              <div>
                <span
                  id="DOWNLOAD_MENUS"
                  onClick={() => setDownloadMenus(!downloadMenus)}
                  className={`link px-[30px] text-center text-[14px] xl:text-[16px] ${
                    type === "home"
                      ? "text-[#333] text-shadow-normal"
                      : "text-[#333]"
                  }`}
                >
                  {lang === "en" ? item.nameEN : item.name}
                </span>
                <DownloadMenus
                  downloadList={[item.ios, item.android]}
                  visible={downloadMenus}
                  onClose={closeDownloadMenus}
                />
              </div>
            ) : null
          ) : (
            <a
              key={index}
              onClick={() => navigate(item.path)}
              style={navStyle}
              className={`link px-[30px] text-center text-[14px] xl:text-[16px] ${
                type === "home"
                  ? "text-white text-shadow-normal"
                  : "text-[#333]"
              }`}
            >
              {lang === "en" ? item.nameEN : item.name}
            </a>
          )}
        </div>
      ))}
    </div>
  );
}
